import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpContext} from "@angular/common/http";
import {Observable, share, single} from "rxjs";
import {IGNORE_LOADING} from "../../interceptors/loading_interceptor";
import {IGNORE_400_ERROR} from "../commons/interceptor/http400-interceptor";
import {IGNORE_5XX_ERROR} from "../commons/interceptor/http5xx-interceptor";
import {UserData} from "../../../generated-model/model";
import {environment} from "../../../environments/environment";

@Injectable({providedIn: "root"})
export class UserDataResource {
  http = inject(HttpClient);
  public userData$;

  constructor() {
    const httpContext = new HttpContext();
    httpContext.set(IGNORE_LOADING, true)
    httpContext.set(IGNORE_400_ERROR, true);
    httpContext.set(IGNORE_5XX_ERROR, true);
    this.userData$ = this.http.get<UserData>(`${environment.serverUrl}/public/api/user-data`, {context: httpContext})
      .pipe(
        single(e => !!e),
        share()
      );
  }

  getUserData(): Observable<UserData> {
    return this.userData$;
  }
}
